import React from "react"
import {
  Box,
  BasicInfoContainer,
  IconCover,
  InfoCard,
  InfoCards,
  InfoCover,
  InfoSec,
  Title,
} from "./basicStyles"
import { StaticImage } from "gatsby-plugin-image"
import data from "../../../assets/data.json"
import "./basicinfo.scss"

const BasicInfo = (props) => {
  const { isCertificate } = props
  const {
    duration,
    netFee,
    courseReference,
    trainingMode,
    price,
    skillsCode,
    skillsCodeName,
    cpdPoint,
    time,
  } = props

  return (
    <>
      <BasicInfoContainer>
        <InfoSec>
          <InfoCards>
            <Title>About Course</Title>

            {/* Location */}
            {/* <InfoCard>
              <IconCover>
                <StaticImage src="../../../assets/images/location.png" alt="location" />
              </IconCover>
              <InfoCover>
                <h4>Our Location</h4>
                <h5>{data.address}</h5>
              </InfoCover>
            </InfoCard> */}

            {time && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/clockicon.png" alt="clockicon" />
                </IconCover>
                <InfoCover>
                  <h4>Time</h4>
                  <h5>{time}</h5>
                </InfoCover>
              </InfoCard>
            )}

            {/* Training Mode */}
            {trainingMode && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/location.png" alt="location" />
                </IconCover>
                <InfoCover>
                  <h4>Training Mode</h4>
                  <h5>{trainingMode}</h5>
                </InfoCover>
              </InfoCard>
            )}

            {/* Price */}
            {/* {price && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/CourseFee.png" alt="CourseFee" />
                </IconCover>
                <InfoCover>
                  <h4>Course Fee</h4>
                  <h5>
                    ${price} <span className="spanGst">(excluding GST)</span>
                  </h5>
                </InfoCover>
              </InfoCard>
            )} */}

            {/* Duration */}
            {/* {duration && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/clockicon.png" alt="clockicon" />
                </IconCover>
                <InfoCover>
                  <h4>Duration</h4>
                  <h5>{duration} Hours</h5>
                </InfoCover>
              </InfoCard>
            )} */}

            {/* ACRA Info */}
            {/* <InfoCard>
              <IconCover>
                <StaticImage src="../../../assets/images/Acra_icon.png" alt="Acra_icon" />
              </IconCover>
              <InfoCover>
                <h4>ACRA-registered Name</h4>
                <h5>Ace Industrial Academy Pte. Ltd.</h5>
              </InfoCover>
            </InfoCard> */}

            {/* UEN */}
            {/* <InfoCard>
              <IconCover>
                <StaticImage src="../../../assets/images/UEN.png" alt="UEN" />
              </IconCover>
              <InfoCover>
                <h4>UEN</h4>
                <h5>200710151K</h5>
              </InfoCover>
            </InfoCard> */}

            {/* Dynamic Info */}
            {courseReference && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/CourseCode.png" alt="CourseCode" />
                </IconCover>
                <InfoCover>
                  <h4>Course Code</h4>
                  <h5>{courseReference}</h5>
                </InfoCover>
              </InfoCard>
            )}

            {skillsCode && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/Skillcode.png" alt="Skillcode" />
                </IconCover>
                <InfoCover>
                  <h4>Skill Code</h4>
                  <h5>{skillsCode}</h5>
                </InfoCover>
              </InfoCard>
            )}

            {skillsCodeName && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/SkillCodeName.png" alt="SkillCodeName" />
                </IconCover>
                <InfoCover>
                  <h4>Skill Code Name</h4>
                  <h5>{skillsCodeName}</h5>
                </InfoCover>
              </InfoCard>
            )}

            {cpdPoint && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/Acra_icon.png" alt="Acra_icon" />
                </IconCover>
                <InfoCover>
                  <h4>CPD Points</h4>
                  <h5>{cpdPoint}</h5>
                </InfoCover>
              </InfoCard>
            )}

            {/* {netFee && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/NetFee.png" alt="NetFee" />
                </IconCover>
                <InfoCover>
                  <h4>Net Fee after Skillsfuture Funding</h4>
                  <h5>
                    ${netFee} <span className="spanGst">(excluding GST)</span>
                  </h5>
                </InfoCover>
              </InfoCard>
            )} */}

            {isCertificate && (
              <InfoCard>
                <IconCover>
                  <StaticImage src="../../../assets/images/questionMark.png" alt="question" />
                </IconCover>
                <InfoCover>
                  <h4>Questions</h4>
                  <h5>65</h5>
                </InfoCover>
              </InfoCard>
            )}

            {/* Skill Level */}
            {/* <InfoCard>
              <IconCover>
                <StaticImage src="../../../assets/images/SkillLevel.png" alt="SkillLevel" />
              </IconCover>
              <InfoCover>
                <h4>Skill Level</h4>
                <h5>Beginner</h5>
              </InfoCover>
            </InfoCard> */}

            {/* Google Maps Button */}
            <div className="row timing">
              <div className="col-xl-12 mb-4">
                <button>
                  <StaticImage src="../../../assets/images/map.png" alt="map" />
                  <a
                    href="https://www.google.com/maps?ll=1.356379,103.837476&z=16&t=m&hl=en-US&gl=US&mapclient=embed&cid=6210499622005566020"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open In Google Maps
                  </a>
                </button>
              </div>
            </div>
          </InfoCards>
        </InfoSec>
      </BasicInfoContainer>
    </>
  )
}

export default BasicInfo
